import React, { createContext, useContext, useState } from 'react';

const TimeAdjContext = createContext();

export const useTimeAdjContext = () => {
  const context = useContext(TimeAdjContext);
  if (!context) {
    throw new Error('useTimeAdjContext must be used within a TimeAdjContextProvider');
  }
  return context;
};

export const TimeAdjContextProvider = ({ children }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const openDialog = (row) => {
    setSelectedRow(row);
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    setSelectedRow(null);
  };

  return (
    <TimeAdjContext.Provider
      value={{
        isDialogOpen,
        selectedRow,
        openDialog,
        closeDialog,
      }}
    >
      {children}
    </TimeAdjContext.Provider>
  );
};
